<template>
  <div>
    <list-table
      :fields="fields"
      :url="url"
      :excelroute="true"
      :params="params"
    ></list-table>
  </div>
</template>
<script>
import TableShowData from "@/components/table";
import persianDate from "@/helpers/persianDate";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "AccountersReportCreditors",

  data() {
    return {
      url: "accounters-report/creditors",

      fields: [
        {
          key: "website_name",
          label: "نام وبسایت",
        },
        {
          key: "name",
          label: "نام و نام خانوادکی(نام شرکت)",
        },
        {
          key: "com_shenase",
          label: "شناسه اقتصادی",
        },
        {
          key: "register_number",
          label: "شماره ثبت",
        },
        {
          key: "national_card_number",
          label: "کد ملی",
        },
        {
          key: "address",
          label: "آدرس",
        },
        {
          key: "mobile",
          label: "تلفن همراه",
        },
        {
          key: "sumamount",
          label: "مبلغ ناخالص پرداختنی به حساب مشتری",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "sumkarmozd",
          label: "کارمزد درگاه",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "total",
          label: "مبلغ خالص پرداختنی به مشتری",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "sumpayd",
          label: "مبلغ پرداختی به مشتری",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "mustpayd",
          label: "طلب یا بدهی مشتری",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "mdid119_status_date",
          label: "تاریخ فعال سازی",
          formatter(value, key, item) {
            return value != null ? persianDate.getDate(value) : "-";;
          },
        },
      ],

      params: [
        {
          label: "از تاریخ:",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker",
        },
        {
          label: "پذیرنده:",
          field: "gateway_id",
          type: "vselect",
          value: null,
          options: [
          ],
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارشات مالی",
        route: "merchants",
      },
      {
        title: "بستانکاران",
      },
    ]);
    this.getUserList('gateways-with-transaction');
  },
  methods: {
    getUserList(api) {
      this.$store.dispatch(GET_USER_LIST,api).then((data) => {
        let option = [{ text: "انتخاب نشده", value: null }];
        data.forEach((element) => {
          option.push({ text: element.website_name, value: element.id });
        });

        this.params[2].options = option;
      });
    },
  },
};
</script>